module.exports = __webpack_public_path__ + "static/media/min-bio.51b9a121.pdf";